import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import HelpIconPopover from '../HelpIconPopover';

import '../../../styles/report.css'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2'

ChartJS.register(ArcElement, Tooltip, Legend);

const HealthAge = (props) => {

    const labelCenter = {
        id: "labelCenter",
        beforeDraw: (chart, args, options) => {
            if (!Array.isArray(options.labels)) {
                return console.error('"options.lables" must be array', options.lables);
            }

            const {
                ctx,
                chartArea: { width, height }
            } = chart;
            const context = ctx.canvas.getContext("2d");
            context.save();

            const labels = options.labels.slice();
            const totalFontSize = labels.reduce((x, y, index) => {
                let prevSize = x[index - 1] || 0;
                x.push(prevSize + y.font.size);
                return x;
            }, []);

            labels.forEach((label, index) => {
                // position
                //       ows
                //      health age
                //    health age number
                // since the middle is the base.. array 1 is above, 2 is center and 3 is below
                // using em, total fonsize will be 5
                // attempting to just define an array
                let tpos = [-5, 30]
                let textPosition = tpos[index];
                const values = {
                    text: label.text || "?",
                    font: {
                        size: label.font.size || 30,
                        family: label.font.family || "sans-serif",
                        color: label.font.color || "black",
                        style: label.font.style || "normal",
                        unit: label.font.unit || "px"
                    }
                };
                switch (values.font.unit) {
                    case "em":
                        values.font.size = label.font.size * 0.04;
                        textPosition *= 0.8;
                        break;
                    default:
                        break;
                }

                context.font = `${values.font.style} ${values.font.size}${values.font.unit} ${values.font.family}`;
                context.textAlign = "center";
                context.fillStyle = values.font.color;
                context.fillText(values.text, width / 2, height / 2 + textPosition);
            });
            context.restore();
        }
    };

    const WellnessScore = (props) => {
        const ActualAge = props.ActualAge
        const HAge = props.CurrentOWSValue
        const healthAgeGreater = HAge > ActualAge ? true : false
        const maxAge = HAge > ActualAge ? HAge : ActualAge
        const graphcolors = ['#c0c0c0', '#4eb748', '#E7C61E', '#E6323A']
        const GetColor = (score) => {

            const vg = parseInt(score <= 39 ? 3 : score <= 69 ? 2 : score <= 100 ? 1 : 0)
            return graphcolors[vg]
        }

        const ColorBase = '#D2EDD1' // this is the color picker result of 4eb748 with AA alpha
        const Color = '#4eb748'
        const Color2 = '#E6323A'
        const data = {
            labels: ["Health Age"],
            datasets: [
                {
                    label:'Age',
                    data: [ActualAge],
                    backgroundColor: [
                        ColorBase
                    ],
                    borderColor: [
                        'rgba(54, 162, 235, 0)'
                        
                    ],
                    borderSkipped: false,
                    borderWidth: 0,

                    // borderRadius: [30,-20],
                }
                , {
                    label:'Health Age',
                    data: [Math.abs(HAge - ActualAge)],
                    backgroundColor: [
                     
                        healthAgeGreater ? Color2 : Color


                    ],
                    borderColor: [
                        'rgba(54, 162, 235, 0)'
                     

                    ],
                    borderSkipped: false,
                    borderWidth: 0,

                    // borderRadius: [30,-20],
                }
            ],
        }
        const progressbar = {
            id:'progressbar',
            beforeDatasetsDraw(chart, args, pluginsOptions) {
                const { ctx
                        , chartArea:{top, bottom, left, right, width, height} 
                        , scales:{x,y}
                    } = chart;
                
                    ctx.save();
                    // labels
                    ctx.font = '12px'

            }
        }
        const options = {
            // remove hover
            tooltips: {enabled: false},
            hover: {mode: null},
            borderWidth: 0,
            maintainAspectRatio: false,
            indexAxis:'y',
            scales: {
                y: {
                    beginAtZero: true,
                    stacked:true,
                    grid: {
                        display: false,
                        drawBorder:false
                    },
                    ticks: {
                        display: false
                    }
                }, 
                x: {
                    
                    stacked:true,
                    grid: {
                        display: false,
                        drawBorder:false
                    },
                    ticks: {
                        display: false
                    }
                }
            },
            plugins: {
                legend: {
                    display: false
                },
                
            },
        
        }
        const plugins = [labelCenter]
        return <Bar data={data} options={options}  />
    }
    return (
        <Box>
            {props.OWS.HealthAge.HelpText !== '' && (

                <Typography variant="body1" fontWeight="bold" style={{ textAlign: 'center', fontSize: "20px" }}>
                    {props.OWS.HealthAge.Label}
                    <HelpIconPopover Text={props.OWS.HealthAge.HelpText} style={{ top: '-10!important' }} />
                </Typography>
            )}

            <Box >
                <Box>
                    <WellnessScore OWSText={'test'} CurrentOWSValue={props.OWS.HealthAge.Score} ActualAge={props.OWS.HealthAge.Age} />
                </Box>
                <Grid container direction="row" alignItems={"center"} justifyContent={"center"}>
                <Grid items xs={12} md={6}>
                        <Typography align="center" variant="subtitle2">{props.OWS.HealthAge.Label}</Typography>
                        <Typography align="center" variant="h5">{props.OWS.HealthAge.Score}</Typography>
                    </Grid>
                    <Grid items xs={12} md={6}>
                        <Typography align="center" variant="subtitle2">{props.OWS.HealthAge.AgeLabel}</Typography>
                        <Typography align="center" variant="h5">{props.OWS.HealthAge.Age}</Typography>
                    </Grid>
                </Grid>
            </Box>
        </Box>

    )
}


export default HealthAge;